import {User} from "@/models/User";

export interface UserState {
  loggedUser : User | null
}

export enum MutationTypes {
  SET_LOGGED_USER = 'SET_LOGGED_USER',
}

export enum ActionTypes {

}

export enum GetterTypes {
  GET_LOGGED_USER = 'GET_LOGGED_USER',
}